/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const ERROR_MESSAGES = {
  'reb2-utility/v1/devices/validate-SIM': 'Sim validation failed',
  'reb2-customer-manage-profile/v1/customers/creditEmail/search': 'Email validation failed',
  'reb2-customer-manage-profile/v1/addresses': 'Address validation failed',
  'reb2-products/v1/products/plans': 'Fetching plans failed',
  'reb2-customer-manage-profile/v1/profiles/{profileId}/addresses':
    'Updating address to profile failed',
  'reb2-cart/v1/carts/{cartId}/plan-configurations': 'Updating plans to cart failed',
  'reb2-cart/v1/cart': 'Cart creation failed',
  'reb2-cart/v1/carts/{cartId}/lines/{lineId}/audit-records': 'Posting audit records failed',
  'reb2-cart/v1/profiles/{profileId}': 'Updating profile details failed',
  'reb2-cart/v1/profiles/{profileId}/addresses': 'Updating addresses to account failed',
  'reb2-cart/v1/carts/{cartId}/lineSetup': 'Updating phone number to cart failed',
  'reb2-cart/v1/checkout/{cartId}': 'Cart checkout failed',
  'reb2-cart/v1/submit-order/{cartId}': 'Submitting order failed',
  'reb2-orders/v1/orders/{cartId}': 'Fetching order details failed',
  'reb2-risk-assessment/v1/creditCustomerDetails': 'Credit check failed',
  'reb2-risk-assessment/v1/riskassessmentidtypes': 'Fetching risk assessments data failed',
};
